import * as basic from '../../../config/basic'

export const home = {
  introduction: {
    title: '大赛介绍',
    subTitle: 'FinTechathon',
    intro: [
      '<span class="intro-paragraph">2026深圳国际金融科技大赛——微众银行金融科技大学生挑战赛，由深圳市地方金融管理局、深圳大学、微众银行联合作为战略指导单位，深圳大学微众银行金融科技学院主办，<strong class="intro-highlight">已连续举办八届</strong>，累计沉淀数千个优秀作品，吸引近万名海内外高校学子参与，持续推动金融科技的技术创新、人才培养与产学研交流。</span><span class="intro-paragraph">顺应全球人工智能发展热潮，<strong class="intro-highlight">大赛全新升级国际赛道（人工智能方向）</strong>，恰逢2026年APEC峰会落地深圳，大赛借此契机，着眼于人工智能技术给全球经济社会发展带来的深刻变革，以更开放的国际视野升级赛制，面向全球高校扩大招募。</span><span class="intro-paragraph">本次大赛特邀<strong class="intro-highlight">中国计算机学会数字金融分会、清华大学金融科技研究院、IEEE计算智能学会新加坡分会、IEEE计算智能学会深圳分会</strong>担任技术指导单位，多位行业专家出任学术顾问与评委，为参赛团队提供从赛制设计到作品评审的全程专业支持。诚邀海内外高校学子共同探索金融科技与人工智能的创新未来！</span>'
    ],
    poster: require('@/assets/img/banner_wap.png'),
    video: 'https://v-blog.csdnimg.cn/asset/537606488dd4b9ed351e46228dc58886/play_video/1f85a257f1c0b478995495d99cf99a94.mp4'
  },

  wxShare: {
    title: '深圳国际金融科技大赛——西丽湖金融科技大学生挑战赛',
    introduce: '2026深圳国际金融科技大赛——西丽湖金融科技大学生挑战赛，面向金融科技、人工智能等前沿技术领域。大赛已连续举办八年，吸引近万名海内外高校学子参与，并沉淀数千件优秀金融科技作品。',
    img: require('@/assets/transSave/resource/image/42/d9/42ee921bd490be84367e6c105e1bfed9.jpg')
  },

  bars: [
    {
      name: '大赛介绍',
      id: '#introduction'
    },
    {
      name: '新闻资讯',
      id: '#news'
    },
    {
      name: '赛题说明',
      id: '#note'
    },
    {
      name: '大赛日程',
      id: '#schedule'
    },
    {
      name: '奖项设置',
      id: '#awards'
    },
    {
      name: '特邀顾问',
      id: '#judge'
    },
    // {
    //   name: '大赛评委',
    //   id: '#judgeSaidao'
    // },
    {
      name: '直播回顾',
      id: '#videos'
    },
    {
      name: '合作伙伴',
      id: '#partners'
    }
  ],
  barQrcodeList: [
    {
      id: 'AI',
      img: basic.aiLogoGrey,
      hoverImg: basic.aiLogoBlack,
          qrcode: require('@/assets/img/ai-assistant-qr-2026.png'),
      name: '人工智能小助手'
    },
    {
      id: 'blockchain',
      img: basic.blockchainLogoGrey,
      hoverImg: basic.blockchainLogoBlack,
      qrcode: require('@/assets/img/data-analysis-assistant-qr-clean.png'),
      name: '数据分析小助手'
    },
    // {
    //   id: 'pm',
    //   img: basic.pmLogoGrey,
    //   hoverImg: basic.pmLogoBlack,
    //   qrcode: require('@/assets/img/qr-cp.png'),
    //   name: '产品经理小助手'
    // }
  ],

  nav: [
    {
      title: '赛题设置',
      name: 'Home',
      // hash: '#note',
      id: 1
    },
    {
      title: '参赛规则',
      name: 'Rule',
      id: 2
    },
    {
      title: '往届回顾',
      name: '',
      id: 3,
      children: [
        {
          title: '2025 第七届',
          name: 'Past2025',
          id: 3.6
        },
        {
          title: '2024 第六届',
          name: 'Past2024',
          id: 3.5
        },
        {
          title: '2023 第五届',
          name: 'Past2023',
          id: 3.4
        },
        {
          title: '2022 第四届',
          name: 'Past2022',
          id: 3.0
        },
        {
          title: '2021 第三届',
          name: 'Past2021',
          id: 3.1
        },
        {
          title: '2020 第二届',
          name: 'Past2020',
          id: 3.2
        },
        {
          title: '2019 第一届',
          name: 'Past2019',
          id: 3.3
        }
      ]
    },
    // {
    //   title: '学习园地',
    //   name: '',
    //   id: 4,
    //   children: [
    //     {
    //       title: '人工智能',
    //       name: 'SupportAI',
    //       id: 4.2
    //     },
    //     {
    //       title: '区块链',
    //       name: 'SupportBlockchain',
    //       id: 4.1
    //     },
    //     {
    //       title: '产品经理',
    //       name: 'SupportPM',
    //       id: 4.3
    //     }
    //   ]
    // },
    {
      title: '主办方介绍',
      name: 'Home',
      // hash: '#partners',
      id: 5,
      children: [
        {
          title: '深圳大学微众银行金融科技学院',
          name: 'https://swift.szu.edu.cn/index.htm',
          id: 5.1
        },
        {
          title: '微众银行',
          name: 'https://www.webank.com/',
          id: 5.2
        }
      ]
    }
  ],

  note: [
    {
      region: 'domestic',
      type: 'ai',
      logo: basic.aiLogoBg,
      title: '人工智能赛道',
      introTitle: '银行 AI 智能体',
      subjectDetailKey: 'aiDomestic',
      // subtitle:'本次竞赛以“AI 时代的智能金融体验”为主体，鼓励用生成式 AI 的能力帮助用户深度、低门槛地体验数字金融世界带来的种种便利，开放方向包括但不限于金融产品推荐问答、个人消费账单管理、个人金融投资配置、个人发票管理……提交的作品方案需包括需求分析、系统设计及实现、效果评测等内容，以便参与决赛的汇报答辩，创意出众，尤其是能与现代数字银行应用丝滑集成的作品，将获得额外加分。',
      intro: '国内赛道聚焦“AI 代人操作银行”（安全 + 体验），参赛团队需构建一个 AI Banking Agent 系统，通过自然语言对话理解用户金融意图，自主规划并执行银行业务操作，并支持通过 APP、IM 等渠道与用户连接。系统至少覆盖下列 3 个核心场景，鼓励完整覆盖全部场景。',
      // introbg: require('@/assets/transSave/resource/image/e9/b2/e9194197aef9b1c408d3143c08d553b2.png'),
      scenarios: [
        { index: '01', title: '智能转账', text: '按人名、手机号或备注转账；定时转账；拆分 AA 收款' },
        { index: '02', title: '账单分析', text: '消费分类统计；异常交易识别；月度 / 年度账单报告' },
        { index: '03', title: '理财操作', text: '产品推荐与对比；风险评估；一键申购 / 赎回' },
        { index: '04', title: '卡片管理', text: '卡申请；额度调整；交易限制 / 解锁；卡片挂失' },
        { index: '05', title: '订阅 / 代扣管理', text: '自动识别订阅扣费；续费提醒；一键取消订阅' },
        { index: '06', title: '跨场景联动', text: '例如：识别生日需求，锁定资金并自动完成鲜花、蛋糕等服务预订' }
      ],
      warn: '比赛题目（包括且不限于以下三个方向，欢迎大家积极探索区块链与更多场景结合的可能性）',
      moreBtn: {
        details: '赛题解析',
        detailsText: {
          title: '赛题解析',
          // warn: '（以下题目仅供参考）',
          // content: '数字化浪潮的推动下，以区块链技术为支撑的金融服务体系正渗透到各种业务流程环节中，随千行百业不同业务环境的推进而落地。为探索让区块链技术更好更安全地应用于金融领域，参赛者需要结合金融领域的真实场景，设计一个系统，探索金融业务创新，为金融机构及用户提供安全、高效、透明的金融服务。如探索区块链技术在保险、信贷等领域的应用，研究区块链技术在绿色金融、普惠金融等领域的应用,等。参照作品可考虑以下几点：',
          illustrate: [
            {
              id: '01',
              illustrateContent: '国内赛道聚焦“AI 代人操作银行”（安全+体验），共同探索 AI Agent 在金融领域的下一个范式。AI 正在从金融工具变成金融参与者——这一变革将深刻影响银行、支付、理财、保险等每一个金融子行业。我们诚邀全国高校在读学生组队参赛，共同探索这一前沿命题。',
            },
          ],
          illustrateWarn: ''
          // illustrateWarn: '注：以上赛题仅供参考，欢迎大家积极探索更多ESG相关的使用场景。'
        },
        understandMore: '学习园地',
        understandMoreLink: '/support/blockchain'
      }
    },
    {
      region: 'domestic',
      type: 'blockchain',
      logo: basic.blockchainLogoBg,
      title: '数据分析赛道',
      // 默认显示第一个tab的内容
      subtitle: '围绕金融科技真实业务场景设五道赛题，考察参赛者在数据获取、分析建模与业务落地上的综合能力。参赛团队任选一题作答。',
      intro: '围绕金融科技真实业务场景设五道赛题，参赛团队任选一题作答。',
      introbg: require('@/assets/transSave/resource/image/a7/83/a7e887f917f58662a913bd237dacda83.png'),
      moreBtn: {
        tabText: [
          '赛题一',
          '赛题二',
          '赛题三',
          '赛题四',
          '赛题五'
        ],
        details: '查看完整赛题',
        // 每个tab对应的完整信息
        tabInfoArr: [
          {
            introTitle: '授信客户风险评分稳定性研究',
            intro: '研究目标：构建一个兼具高区分度与良好稳定性的授信客户风险评分模型。该模型一方面需充分捕捉客户在基础资质、经营状况、负债水平等多维度风险因子上的差异，确保对客户信用质量有精准的判断能力；另一方面，在客户核心特征未发生实质性变化的前提下，模型应保持输出结果的平稳性，确保同类客户在不同时点下的评分具备合理一致性与可比性。',
            detailsText: {
              title: '可寻找的数据源（建议）',
              illustrate: [
                {
                  id: '1',
                  illustrateContent: '1.	企业基本面信息（核心）：<br/>数据源： 国家企业信用信息公示系统（但需手动爬取，注意合规性）、北京大学开放研究数据平台（提供部分企业相关研究数据）。<br/>可获取的数据： 企业注册资本、成立年限、股东信息、行政处罚、是否上市等。<br/>链接：<br/> <a href="http://www.gsxt.gov.cn/index.html" target="_blank">http://www.gsxt.gov.cn/index.html</a><br/><a href="https://opendata.pku.edu.cn/" target="_blank">https://opendata.pku.edu.cn/</a>（搜索"企业"）',
                },
                {
                  id: '2',
                  illustrateContent: '2.	行业与宏观环境数据：<br/>数据源： 国家统计局、各地市政府数据开放平台。<br/>可获取的数据： 分行业的景气指数、宏观经济指标（GDP、CPI）、区域政策法规、专利数据等。<br/>链接：<br/> <a href="http://www.stats.gov.cn/" target="_blank">http://www.stats.gov.cn/</a><br/><a href="https://www.dataplanet.cn/" target="_blank">https://www.dataplanet.cn/</a>（聚合了各地方政府开放数据）',
                },
                {
                  id: '3',
                  illustrateContent: '3.	网络影响力与舆情数据：<br/>数据源： 百度指数、新浪微热点。<br/>可获取的数据： 企业或品牌名的搜索指数、媒体资讯指数、网络口碑（需通过API或爬虫获取，注意频率）。<br/>链接：<br/> <a href="https://index.baidu.com/v2/index.html" target="_blank">https://index.baidu.com/v2/index.html</a><br/><a href="http://www.wrd.cn/" target="_blank">http://www.wrd.cn/</a>',
                },
              ],
              illustrateWarn: ''
            }
          },
          {
            introTitle: '基于应用图谱信息的经营类客户风控模型的构建',
            intro: '研究目标：构建一个面向经营类客户的风控评分模型，将企业关联图谱数据作为模型输入的重要组成部分。具体而言，模型需纳入客户与上下游合作方之间的业务关联、客户与股东、实控人、投资人之间的股权及人员关联，以及各关联主体所产生的逾期、涉诉、失信等风险事件的时序信息。通过系统挖掘多层级的隐性风险传导路径，模型应能充分捕捉主体间的风险联动逻辑，从而在更广维度上识别潜在风险信号，显著提升对经营类客户信用风险的预测准确性。',
            detailsText: {
              title: '可寻找的数据源（若需自行寻找）',
              warn: '',
              content: '背景：生成式AI技术的迅速发展，为金融领域带来新的机遇和挑战。生成式AI可以生成逼真的文本、图像、视频、音频等内容，已被广泛应用于客服、营销、个性化推荐、广告素材生成等金融业务中。然而，这些技术的滥用也带来了巨大的安全隐患。黑客和欺诈者可以利用生成式AI伪造虚假信息，从而绕过现有的金融防御体系，骗取巨额资金。为此，金融行业机构急需创新的反欺诈技术，以有效应对生成式AI带来的新型威胁，保护客户的资金和数据安全，维护金融市场的稳定。',
              illustrate: [
                {
                  id: '1',
                  illustrateContent: '数据源： IEEE-CIS Fraud Detection Dataset (Kaggle)<br/>描述： 这是行业标杆级的欺诈检测公开数据集，来自Vesta公司的真实电商交易数据，经过充分脱敏。包含数十万个交易样本，几百个特征字段（如交易金额、产品类型、设备信息、网络IP信息等）。<br/>链接： <a href="https://www.kaggle.com/c/ieee-fraud-detection/data" target="_blank">https://www.kaggle.com/c/ieee-fraud-detection/data</a> ',
                },
              
              ],
              illustrateWarn: ''
            }
          },
          {
            introTitle: '基于公开数据的小微企业经营风险指标体系构建及验证',
            intro: '研究目标：针对小微企业因经营风险高、可用数据稀疏而导致评估困难的现实业务痛点，本赛题旨在探索在现有经营流水数据基础之上，引入多维度公开数据以提升风险评估能力的可行性。参赛者可灵活运用任何可合法获取的公开数据来源，通过外部信息的整合为小微企业构建更立体的风险画像，进而优化信用风险识别逻辑，切实提升金融机构对小微企业风险的评估精度与前瞻预判能力。',
            detailsText: {
              title: '可寻找的数据源（若需自行寻找）',
              warn: '',
              illustrate: [
                {
                  id: '1',
                  illustrateContent: '数据源： Bank Marketing Dataset (UCI Machine Learning Repository)<br/>描述： 该数据集源自葡萄牙银行机构的营销活动记录，与赛题场景高度契合。包含客户的基本信息（年龄、职业等）、上次营销接触的情况、经济指标（如就业变化率）等。<br>目标变量： 客户是否订阅了定期存款（这可以巧妙地映射为“是否流失”或“是否激活”）。<br/>链接： <a href="https://archive.ics.uci.edu/ml/datasets/Bank+Marketing" target="_blank">https://archive.ics.uci.edu/ml/datasets/Bank+Marketing</a> ',
                },
              
              ],
              illustrateWarn: ''
            }
          },
          {
            introTitle: '刷单等非规范经营行为的识别',
            intro: '研究目标：构建一套专门识别非规范行为的算法，系统性地识别客户为抬高授信水平而实施的刷单、虚构交易、伪造流水等虚假经营操作。通过对真实经营流水与虚假交易数据进行深度对比分析，建立有效的判别逻辑，挖掘虚假交易区别于正常经营活动的量化特征与规律模式，最终为授信审批环节提供真实、可靠的交易数据基础，确保风控评估结果的客观性与准确性。',
            detailsText: {
              title: '可寻找的数据源（若需自行寻找）',
              warn: '',
              illustrate: [
                {
                  id: '1',
                  illustrateContent: '社交网络数据：<br/>数据源： Stanford Large Network Dataset Collection (SNAP)<br/>描述： 包含大量经典的社交网络数据集，如Facebook、Twitter、Epinions等社交图谱数据，节点代表用户，边代表关注、好友等关系。<br/>链接： <a href="https://snap.stanford.edu/data/" target="_blank">https://snap.stanford.edu/data/</a> ',
                },
                {
                  id: '2',
                  illustrateContent: '金融产品扩散/采纳行为数据：<br/>数据源： ** Kickstarter Projects Dataset** (Kaggle)<br/>描述： 这是最接近“产品扩散”概念的公开数据。包含了众筹项目的详细信息（如目标金额、已筹金额、支持者数量、项目类别）以及时间序列的筹资情况。<br/>链接： <a href="https://www.kaggle.com/datasets/kemical/kickstarter-projects" target="_blank">https://www.kaggle.com/datasets/kemical/kickstarter-projects</a> ',
                },
                {
                  id: '3',
                  illustrateContent: '如何关联？可以模拟或假设：在社交网络中的某个节点（用户）支持了某个项目，然后分析该行为如何通过其社交关系网络影响其朋友（邻居节点）。<br/>链接： <a href="https://www.kaggle.com/datasets/kemical/kickstarter-projects" target="_blank">https://www.kaggle.com/datasets/kemical/kickstarter-projects</a> ',
                },
              
              ],
              illustrateWarn: ''
            }
          },
          {
            introTitle: '基于原始量价数据的股票收益预测',
            intro: `在量化投资中，利用历史量价数据预测股票未来收益是核心研究课题之一。<a class="data-source-highlight" href="https://pan.baidu.com/s/1aR4M-Q_vkr8gQrXstMXWgg?pwd=ea9b" target="_blank" rel="noopener noreferrer" aria-label="打开百度网盘下载全市场 A 股日线级别量价数据，324 MB">本次比赛提供全市场 A 股的日线级别量价数据</a>，要求参赛选手构建预测模型，对测试集中每只股票每个交易日的未来一天收益率进行预测。对测试集中每条记录（ts_code + trade_date），预测其对应的 y_ret_1d（未来一天收益率）。`,
            dataDownload: {
              url: 'https://pan.baidu.com/s/1aR4M-Q_vkr8gQrXstMXWgg?pwd=ea9b',
              label: '赛题数据下载',
              meta: '百度网盘 · 324 MB',
              ariaLabel: '打开百度网盘下载赛题数据，324 MB'
            },
            detailsText: {
              title: '可寻找的数据源（建议）',
              illustrate: [
                {
                  id: '1',
                  illustrateContent: '数据源：比赛提供的全市场 A 股日线级别量价数据。<br/>预测目标：测试集中每条记录（ts_code + trade_date）对应的 y_ret_1d（未来一天收益率）。'
                }
              ],
              illustrateWarn: ''
            }
          }
        ],
        understandMore: '学习园地',
        understandMoreLink: '/support/ai'
      }
    },
    {
      region: 'international',
      type: 'ai',
      logo: basic.aiLogoBg,
      title: '人工智能赛道',
      introTitle: 'AI 金融参与者',
      intro: '以下方向均围绕「AI 金融参与者」命题展开，参赛团队任选其一深入实现。方向 A–E 为本次新增 / 扩展方向，方向 F 为原 Agent Wallet。选一个你能驾驭的方向，做出会「理解、规划、安全执行」的金融 Agent。',
      directions: [
        { index: 'A', title: 'AI 个人金融助理', text: '对话即可办事：记账、预算与账单管理' },
        { index: 'B', title: 'AI 理财助理', text: '风险测评、资产配置与模拟投资规划' },
        { index: 'C', title: '跨境 / 留学生金融助手', text: '多币种、汇率、跨境汇款与多语言服务（APEC 特色）' },
        { index: 'D', title: 'AI 保险助理', text: '保单解读、方案推荐与理赔引导' },
        { index: 'E', title: '小微企业财务助手', text: '现金流、对账与经营建议' },
        { index: 'F', title: 'Agent Wallet', text: 'AI 自主拥有钱包，实现真实链上花钱' }
      ],
      warn: '比赛题目（包括且不限于以下三个方向，欢迎大家积极探索区块链与更多场景结合的可能性）',
      moreBtn: {
        details: '赛题解析',
        detailsText: {
          title: '赛题解析',
          illustrate: [
            {
              id: '01',
              illustrateContent: '以下方向均围绕「AI 金融参与者」命题展开，参赛团队任选其一深入实现。方向 A–E 为本次新增 / 扩展方向，方向 F 为原 Agent Wallet。选一个你能驾驭的方向，做出会「理解、规划、安全执行」的金融 Agent。<br/><br/>方向 A：AI 个人金融助理；方向 B：AI 理财助理；方向 C：跨境 / 留学生金融助手；方向 D：AI 保险助理；方向 E：小微企业财务助手；方向 F：Agent Wallet。'
            }
          ],
          illustrateWarn: ''
        },
        understandMore: '学习园地',
        understandMoreLink: '/support/blockchain'
      }
    }
  ],

  review: {
    btn: {
      link: 'https://fintech.webank.com/past-events/fintechathon-2019/',
      name: '2019 赛事回顾'
    },
    left: {
      poster: require('@/assets/img/video_img.png'),
      video: 'http://1258566428.vod2.myqcloud.com/2056e5f1vodcq1258566428/a0e904b15285890806028324769/tI6SMGAAHVgA.mp4'
    },
    right: [
      {
        img: require('@/assets/img/review/1.jpg'),
        link: '',
        h3: '2019年 FinTechathon 微众银行首届金融科技高校技术大赛'
      },
      {
        img: require('@/assets/img/review/2.jpg'),
        link: '',
        h3: '人工智能赛道评委主席杨强、区块链赛道评委主席马智涛为人工智能赛道第一名团队颁奖'
      },
      {
        img: require('@/assets/img/review/3.jpg'),
        link: '',
        h3: '人工智能赛道评委主席杨强、区块链赛道评委主席马智涛为区块链赛道第一名团队颁奖'
      },
      {
        img: require('@/assets/img/review/4.jpg'),
        link: '',
        h3: '2019年08月26日，微众银行首届金融科技高校技术大赛颁奖典礼现场'
      },
      {
        img: require('@/assets/img/review/5.jpg'),
        link: '',
        h3: '2019年08月26日，微众银行首届金融科技高校技术大赛颁奖典礼现场'
      },
      {
        img: require('@/assets/img/review/6.jpg'),
        link: '',
        h3: '2019年08月26日，Brett King 带来主题为《未来银行4.0 》的精彩分享'
      },
      {
        img: require('@/assets/img/review/7.jpg'),
        link: '',
        h3: '2019年08月24日-25日，两天一夜的黑客松比赛现场'
      },
      {
        img: require('@/assets/img/review/8.jpg'),
        link: '',
        h3: '人工智能赛道的技术支持老师在为参赛选手解疑答惑'
      },
      {
        img: require('@/assets/img/review/9.jpg'),
        link: '',
        h3: '区块链赛道的技术支持老师在为参赛选手解疑答惑'
      },
      {
        img: require('@/assets/img/review/10.jpg'),
        link: '',
        h3: '人工智能赛道的选手进行路演答辩'
      },
      {
        img: require('@/assets/img/review/11.jpg'),
        link: '',
        h3: '区块链赛道的选手进行路演答辩'
      },
      {
        img: require('@/assets/img/review/12.jpg'),
        link: '',
        h3: '2019年08月26日，微众银行首届金融科技高校技术大赛颁奖典礼现场'
      }
    ]
  },

  schedule: {
    title: {
      h1: '大赛日程',
      titleBg: require('@/assets/img/title-bg.png')
    },
    timezone: '所有日期均为中国标准时间（UTC+8）',
    common: [
      { date: '08.31', title: '报名启动' },
      { date: '09.15', title: '第一场线上直播' },
      { date: '09.17', title: '第二场线上直播' }
    ],
    tracks: [
      {
        key: 'domestic-ai',
        label: '人工智能赛道（国内）',
        events: [
          { date: '10.28', title: '线上答疑' },
          { date: '11.02', title: '作品提交截止' },
          { date: '11.10', title: '决赛入围公布（10 强）' },
          { date: '11.28—11.29', title: '人工智能黑客马拉松' }
        ]
      },
      {
        key: 'data',
        label: '数据分析赛道',
        events: [
          { date: '10.12', title: '初赛作品提交截止' },
          { date: '10.18', title: '公布入围复赛名单' },
          { date: '11.02', title: '复赛作品提交截止' },
          { date: '11.10', title: '决赛入围公布' },
          { date: '11.29', title: '数据分析线下答辩' }
        ]
      },
      {
        key: 'international-ai',
        label: '人工智能赛道（国际）',
        featured: true,
        events: [
          { date: '10.20', title: '报名与作品提交截止' },
          { date: '10.21', title: '合规初筛' },
          { date: '10.23', title: '线上评审' },
          { date: '10.31', title: '入围公布·发邀请函' },
          { date: '11.27', title: '办理入住、参观微众银行' },
          { date: '11.29', title: '线下答辩' }
        ]
      }
    ],
    finale: { date: '11.30', title: '颁奖典礼', place: '深圳' },
    subTitle: '*在大赛过程中，如因受到不可抗力因素或其他外部因素影响，发生了赛果、决赛形式、赛制、答辩规则等内容调整的情况，大赛组委会将通过大赛官网、邮件及大赛助手进行通知。',
  },

  prize: {
    title: {
      h1: '奖项设置',
      titleBg: require('@/assets/img/title-bg.png')
    },
    desc: '',
    highlights: {
      title: '大赛特色',
      prizeLabel: '总奖金池',
      prizeValue: '75',
      prizeUnit: '万元',
      prizeMeta: '',
      featureTitle: '专业赛事体系',
      features: [
        {
          index: '01',
          title: '八届赛事积淀',
          text: '持续深耕高校金融科技创新，已沉淀数千件优秀作品，吸引近万名海内外高校学子参与。'
        },
        {
          index: '02',
          title: '权威技术指导',
          text: '由中国计算机学会数字金融分会、清华大学金融科技研究院、IEEE 计算智能学会新加坡分会及深圳分会提供技术指导。'
        },
        {
          index: '03',
          title: '国际化赛制升级',
          text: '人工智能国际赛道以英文为官方语言，面向海外及 APEC 经济体高校招募，促进全球青年技术交流。'
        },
      ],
      awardSubtitle: '',
      awardTitle: '',
      awardMeta: '',
      note: '人工智能赛道（国内）、人工智能赛道（国际）与数据分析赛道分别产生一等奖、二等奖、三等奖、最佳创意奖各 1 队；单赛道奖金合计 25 万元，三大赛道总奖金池 75 万元。获奖团队将获得实体证书及奖杯，所有奖金均为税前金额。',
      awards: [
        { rank: '一等奖', amount: '10 万元' },
        { rank: '二等奖', amount: '8 万元' },
        { rank: '三等奖', amount: '5 万元' },
        { rank: '最佳创意奖', amount: '2 万元' }
      ]
    },
    prizes: [
      {
        type: 'ai',
        list: [
          {
            img: require('@/assets/transSave/resource/image/7e/7e/7e4b87a534ecc6yy7ffbfe4f8321d47e.png'),
            price: require('@/assets/transSave/resource/image/dc/ac/dc020bdea744674c7b180f679fa9ccac.png'),
            rank: require('@/assets/transSave/resource/image/e5/2f/e518ed97f3c315d95b74eb0c1eddbf2f.png')
          }
        ]
      },
      {
        type: 'block',
        list: [
          {
            img: require('@/assets/transSave/resource/image/fc/b2/fc9bf9cf8a5a8266c73139ba6a22f6b2.png'),
            price: require('@/assets/transSave/resource/image/5c/b7/5cf81cc9e91d2065c0e479a8d93d14b7.png'),
            rank: require('@/assets/transSave/resource/image/82/31/82efc9b1e7aa42bb43b8154b379fe831.png')
          }
        ]
      },
      {
        type: 'good',
        list: [
          {
            img: require('@/assets/transSave/resource/image/c8/59/c8e2633a9348bd76435318c1383f8359.png'),
            price: require('@/assets/transSave/resource/image/e4/11/e44d34f8cc1db989ba65c211849b8a11.png'),
            rank: require('@/assets/transSave/resource/image/b9/03/b94acbdb5e83e0c976738edea2655b03.png')
          }
        ]
      }
    ],
    hint: '˙*人工智能、区块链、产品经理赛道中产生一等奖、二等奖、三等奖各一人',
    competitionImg: require('@/assets/transSave/resource/image/ce/9f/ce95b727cd4dddb28f8e2f0144c88a9f.png'),
    competitionBright: [
      {
        img: require('@/assets/transSave/resource/image/46/62/462c670ba013c2cf659ccf5dfc83c762.png'),
        text: '69万奖金池'
      },
      {
        img: require('@/assets/transSave/resource/image/59/3d/593b6fa3aa2cdf8c0bc0ef46f5f1443d.png'),
        text: '获奖证书和奖杯'
      }
    ],
    competitionSchool: {
      school: ['微众银行', '极客邦科技', '金链盟', ' FISCO BCOS', '赛氪', 'DC竞赛网', '深圳大学', '和鲸社区'],
      interviewIcon: require('@/assets/transSave/resource/image/49/3f/49beda842d0775c4yy28efd644c2653f.png'),
      interview: '实习面试直通车'
    }
  },

  judges: [
    {
      title: {
        h1: '特邀学术顾问',
        titleBg: require('@/assets/transSave/resource/image/b2/68/b2549fc7a2c357acb811d10525df6e68.png'),
        tip: ''
      },
      list: [
        {
          headImg: require('@/assets/img/judges/汪寿阳-4x.png'),
          name: '汪寿阳',
          title: '中国科学院特聘研究员、发展中国家科学院院士、国际系统与控制科学院院士、国家级高层次人才、国家杰青'
        },
        {
          headImg: require('@/assets/img/judges/杨强-4x.png'),
          name: '杨强',
          title: '微众银行首席 AI 顾问、加拿大皇家科学院院士、加拿大工程院院士'
        },
        {
          headImg: require('@/assets/img/judges/李文荣-4x.png'),
          name: '李文荣',
          title: '香港城市大学副校长、美国国家人工智能科学院院士、加拿大工程院外籍院士'
        },
        {
          headImg: require('@/assets/img/judges/李坚强-4x.png'),
          name: '李坚强',
          title: '深圳大学人工智能学院院长、深圳大学大数据系统计算技术国家工程实验室执行主任、国家杰青'
        },
        {
          headImg: require('@/assets/img/judges/柴云鹏-4x.png'),
          name: '柴云鹏',
          title: '中国人民大学信息学院院长、党委副书记，教授、博士生导师'
        },
        {
          headImg: require('@/assets/img/judges/修大成.png'),
          name: '修大成',
          title: '芝加哥大学 Booth 商学院 Joseph Sondheimer 计量经济学、统计学与金融学讲席教授'
        },
        {
          headImg: require('@/assets/img/judges/Wolfgang-Hardle-4x.png'),
          name: 'Wolfgang Karl Härdle',
          title: '德国柏林洪堡大学经济商学院终身教授、统计与计量研究所数据研究中心主任、数字资产研究所主任'
        },
        {
          headImg: require('@/assets/img/judges/Joshua-Bongard-4x.png'),
          name: 'Joshua Bongard',
          title: '美国佛蒙特大学计算机科学系维诺特教授（Veinott Professor）、形态学进化与认知实验室主任'
        },
      ]
    },
    // {
    //   title: {
    //     h1: '特邀行业顾问',
    //     titleBg: require('@/assets/img/title-bg.png'),
    //     tip: '（按姓氏首字母排序）'
    //   },
    //   list: [
    //     // {
    //     //   headImg: require('../../../assets/img/judges/11.png'),
    //     //   name: '黄宇铮',
    //     //   title: '博裕资本董事总经理'
    //     // },
    //     {
    //       headImg: require('../../../assets/img/judges/12.png'),
    //       name: '刘明',
    //       title: '鹏城实验室人工智能开源平台办公室主任<br/>OpenI启智新一代人工智能开源开放平台秘书处秘书长'
    //     }
    //     // {
    //     //   headImg: require('../../../assets/img/judges/13.png'),
    //     //   name: '钟惠馨',
    //     //   title: '麦肯锡全球董事、合伙人'
    //     // }
    //   ]
    // }
  ],

  judgeSaidao: [
    {
      id: 0,
      type: 'ai',
      logo: basic.aiLogo,
      logoBlack: basic.aiLogoBlack,
      logoGrey: basic.aiLogoGrey,
      fontActiveBgColor: '#FEE7E5',
      fontActiveColor: '#E1574D',
      title: '人工智能赛道',
      mobileTitle: '人工智能',
      titleBgColor: 'linear-gradient(270deg,rgba(253,187,181,0),#fedcda)',
      mobileTitleBgColor: 'linear-gradient(360deg, rgba(253,187,181,0) 0%, #FEDCDA 100%)',
      mainJudge: {
        img: require('@/assets/transSave/resource/image/b7/32/b7d9097c039f2dd46a120ac8ed2fb032.png'),
        mobileImg: require('@/assets/transSave/resource/image/05/bc/0546d0d957de80c67c849edc3251bdbc.png'),
        name: '杨强',
        conTitle: '评委主席',
        position: '加拿大皇家科学院院士、加拿大工程院院士、微众银行首席人工智能官'
      },
      Judgers: {
        title: '赛道评审',
        mobileTitle: '赛道评审',
        bgBg: require('@/assets/transSave/resource/image/fc/b9/fcd1fd153a2be447379276718d45c8b9.png'),
        data: [
          { name: '范力欣', position: '微众银行人工智能首席科学家' },
          { name: '范涛', position: '微众银行人工智能资深研究员' },
          { name: '黄安埠', position: '微众银行人工智能资深研究员' },
          { name: '张文宇', position: '浙江财经大学盈阳金融科技学院院长' },
          { name: '潘微科', position: '深圳大学计算机与软件学院教授' },
          { name: '宋陽秋', position: '香港科技大学计算机与科学工程系副教授' }
        ]
      }
    },
    {
      id: 1,
      type: 'blockchain',
      logo: basic.blockchainLogo,
      logoBlack: basic.blockchainLogoBlack,
      logoGrey: basic.blockchainLogoGrey,
      fontActiveBgColor: '#F2EDFF',
      fontActiveColor: '#7652E1',
      title: '区块链赛道',
      mobileTitle: '区块链',
      titleBgColor: 'linear-gradient(225deg, rgba(225,208,255,0) 0%, #ECE3FF 100%)',
      mobileTitleBgColor: 'linear-gradient(360deg, rgba(225,208,255,0) 0%, #ECE3FF 100%)',
      mainJudge: {
        img: require('@/assets/transSave/resource/image/57/13/576d497b3bce6f644d534a31d4c9e813.png'),
        mobileImg: require('@/assets/transSave/resource/image/5a/cd/5a5c3aa212e01c4da88fb2610d8577cd.png'),
        name: '马智涛',
        conTitle: '评委主席',
        position: '微众银行副行长、首席信息官',
        // borderBg: basic.borderBlueBg,
      },
      Judgers: {
        title: '赛道评审',
        mobileTitle: '赛道评审',
        bgBg: require('@/assets/transSave/resource/image/98/82/988918324ec22729b11b268b754b2a82.png'),
        // borderBg: basic.borderBlueBg,
        data: [
          { name: '姚辉亚', position: '微众银行数字金融发展部负责人<br>金链盟常务副秘书长' },
          { name: '张开翔', position: '微众银行区块链首席架构师' },
          { name: '李辉忠', position: '微众银行区块链底层平台及隐私计算研发负责人' },
          { name: '苏小康', position: '微众银行区块链应用负责人' },
          { name: '祝烈煌', position: '北京理工大学网络空间安全学院党委书记，教授<br>CCF区块链专委会主任' },
          { name: '孙毅', position: '中国科学院计算技术研究所研究员<br />CCF区块链专委会秘书长' },
          { name: '郑子彬', position: '中山大学软件工程学院院长，教授<br>IEEE Fellow，微众学者' },
          { name: '姜宇', position: '清华大学软件学院副教授<br>微众学者' },
          { name: '段斯斯', position: '清华大学高等研究院研究员<br>微众学者' }
        ]
      }
    },
    {
      id: 2,
      type: 'pm',
      logo: basic.pmLogo,
      logoBlack: basic.pmLogoBlack,
      logoGrey: basic.pmLogoGrey,
      fontActiveBgColor: '#E7F2FF',
      fontActiveColor: '#376EFD',
      title: '产品经理赛道',
      mobileTitle: '产品经理',
      titleBgColor: 'linear-gradient(225deg, rgba(187,225,255,0) 0%, #DDEDFF 100%)',
      mobileTitleBgColor: 'linear-gradient(360deg, rgba(187,225,255,0) 0%, #DCECFF 100%)',
      mainJudge: {
        img: require('@/assets/transSave/resource/image/57/13/576d497b3bce6f644d534a31d4c9e813.png'),
        mobileImg: require('@/assets/transSave/resource/image/5a/cd/5a5c3aa212e01c4da88fb2610d8577cd.png'),
        name: '马智涛',
        conTitle: '评委主席',
        position: ' 微众银行副行长、首席信息官'
      },
      Judgers: {
        title: '赛道评审',
        mobileTitle: '赛道评审',
        bgBg: require('@/assets/transSave/resource/image/c0/e7/c0b5cc7467c6bc83eec15fb4183c7fe7.png'),
        data: [
          { name: '周铭', position: '微众银行数字金融发展部-副总经理' },
          { name: '徐峰', position: '微众银行产品专家' },
          { name: '刘江', position: '微众银行DRAM工作室负责人' },
          { name: '朱文涛', position: '微众银行移动科技产品经理' },
          { name: '张凯', position: '广东财经大学-副校长' },
          { name: '陈海强', position: '厦门大学经济学院-副院长' },
          { name: '祁涵', position: ' 深大微众金融科技学院-副院长' }
        ]
      }
    }
  ],

  videos: {
    titleCh: '直播回顾',
    titleEn: '',
    list: [
      {
        imgUrl: 'img/video-2026-qa-session.jpg',
        contentText: '2026深圳国际金融科技大赛技术答疑会',
        video: 'https://www.bilibili.com/video/BV1tJsd6PEN5/'
      },
      {
        imgUrl: 'img/video-2026-session-2.jpg',
        contentText: '2026深圳国际金融科技大赛技术公开课（第二场）',
        video: 'https://www.bilibili.com/video/BV1Eyhk6wEUk/'
      },
      {
        imgUrl: 'img/video-2026-session-1.jpg',
        contentText: '2026深圳国际金融科技大赛技术公开课（第一场）',
        video: 'https://www.bilibili.com/video/BV1Z1hk68Esc/'
      },
      {
        imgUrl: require('@/assets/img/video03.jpg'),
        contentText: '2025 深圳国际金融科技大赛暨微众银行 2026 届校招宣讲会',
        video: 'https://www.infoq.cn/video/Lq9ymrII4Dqf7YNdOGwe'
      },
      {
        imgUrl: require('@/assets/img/video01.jpg'),
        contentText: '2025年深圳国际金融科技大赛 技术公开课',
        video: 'https://www.infoq.cn/video/rawPSuHo8lAayt81lHNi'
      }
    ],
    buttonText: '',
    buttonLink: ''
  },

  news: [
    {
      titleCh: '新闻资讯',
      titleEn: 'NEWS',
      content: {
        list: []
      }
    },
    {
      titleCh: '新闻资讯',
      titleEn: 'NEWS',
      content: {
        list: [
          {
            id: '01',
            idLogo: basic.one,
            idLogoMobile: basic.oneMobile,
            text: '2026深圳国际金融科技大赛总决赛赛程及颁奖典礼调整通知',
            link: 'https://mp.weixin.qq.com/s/Ci5etBbaJ1zWHMLJrSfg_g'
          },
          {
            id: '02',
            idLogo: basic.two,
            idLogoMobile: basic.oneMobile,
            text: '2026第八届深圳国际金融科技大赛正式启动',
            link: 'http://app.xinhuanet.com/news/article.html?articleId=2026090248a13a590ac541ff8c8ae6d62c3bf428'
          },
          {
            id: '03',
            idLogo: basic.three,
            idLogoMobile: basic.twoMobile,
            text: '2025 深圳国际金融科技大赛十强名单揭晓，12 月 6 日深圳大学决赛见！',
            link: 'https://www.infoq.cn/article/b5bP7kH7NMujy5qTYCzM'
          },
          {
            id: '04',
            idLogo: basic.four,
            idLogoMobile: basic.threeMobile,
            text: '关于就业，年轻人找到了与 AI 的"共生模式',
            link: 'https://www.infoq.cn/article/bpUzYYb7iRlTqwwKNHKz'
          },
          {
            id: '05',
            idLogo: basic.five,
            idLogoMobile: basic.fourMobile,
            text: '2025深圳国际金融科技大赛技术公开课来袭！',
            link: 'https://mp.weixin.qq.com/s/vF45CDSGknVjdaf4Sl18Zw'
          },
          {
            id: '06',
            idLogo: basic.sex,
            idLogoMobile: basic.fiveMobile,
            text: '50 万奖金池，学生党狂喜！2025 深圳国际金融科技大赛启动报名啦！',
            link: 'https://www.infoq.cn/news/zhizRJjomadT5vai81Ne'
          },
          {
            id: '07',
            idLogo: basic.sex,
            idLogoMobile: basic.fiveMobile,
            text: '2024深圳国际金融科技大赛圆满落幕：见证金融科技新力量崛起',
            link: 'https://mp.weixin.qq.com/s/mnK8WzdC45oCnYz5KtF-aA'
          }
        ],
        moreLabel: '查看更多开发教程',
        moreLink: 'https://blog.csdn.net/csdnstudent/'
      }
    },
 
  ],

  partners: [
    {
      title: '战略指导单位',
      list: [
        '深圳大学',
        '微众银行'
      ]
    },
    {
      title: '主办单位',
      list: [
        '深圳大学微众银行金融科技学院'
      ]
    },
    {
      title: '承办单位',
      list: [
        '艾瞰未来（北京）科技有限公司',
        '狗熊会'
      ]
    },
    {
      title: '技术指导单位',
      list: [
        '中国计算机学会数字金融分会',
        '清华大学金融科技研究院',
        'IEEE 计算智能学会新加坡分会',
        'IEEE 计算智能学会深圳分会'
      ]
    }
  ]
}
